enum Currency {
  GBP = "GBP",
  EUR = "EUR",
  AUD = "AUD",
  TT = "TT",
  RP = "RP",
  USD = "USD"
}

export default Currency
